<agr-dialog (confirm)="confirm()" [data]="data">
  <div class="container">
    <p>
      {{ 'terms-and-conditions.content1' | translate }}
    </p>
    <p>{{ 'terms-and-conditions.content2' | translate }}</p>

    <a href="https://www.agrifirm.nl/aanbod/organische-meststoffen/" target="_blank">{{
      'terms-and-conditions.link-text' | translate
    }}</a>
  </div>
</agr-dialog>
